module.exports = __webpack_public_path__ + "static/media/store_mentorship.decfd5e9.jpg";